import React, { lazy } from 'react';

// Lazy load tool components
const StoryBook = lazy(() => import('../../components/StoryBook/StoryBook'));
const QuickStories = lazy(() => import('../../components/QuickStoryBook/QuickStories'));
const PhotoBook = lazy(() => import('../../components/PhotoBook/PhotoBook'));
const StoryNarrator = lazy(() => import('../../components/StoryNarrator/StoryNarrator'));

// Tool data structure with route mapping
const tools = [
  {
    id: 'story',
    title: 'Storybook',
    description: 'Create enchanting storybooks with AI-powered storytelling and illustrations. Every page comes alive with KuchiPuchi\'s magical narration, bringing your characters and scenes to life with dynamic voices and immersive sound effects.',
    path: '/app/tools/story',
    component: StoryBook
  },
  {
    id: 'quick-story',
    title: 'Quick Stories',
    description: 'Experience instant storytelling magic with our AI! Create captivating tales in seconds, each one narrated by KuchiPuchi with delightful character voices and sound effects. Perfect for bedtime, car rides, or anytime imagination calls.',
    path: '/app/tools/quick-story',
    component: QuickStories
  },
  {
    id: 'photo-books',
    title: 'Personalized Photo Book',
    description: 'Transform your photos into magical storybooks where your child becomes the hero. KuchiPuchi brings these personal adventures to life with warm narration, character voices, and enchanting sound effects that make every memory an immersive story.',
    path: '/app/tools/photo-books',
    component: PhotoBook
  },
  {
    id: 'story-narrator',
    title: 'Story Narrator',
    description: 'Let KuchiPuchi\'s enchanting voice transform any story into a magical performance. With dynamic character voices, immersive sound effects, and emotion-rich narration, every tale becomes a captivating audio adventure.',
    path: '/app/tools/story-narrator',
    component: StoryNarrator
  }
];

// Helper function to get component by tool ID
export const getToolComponent = (toolId) => {
  const tool = tools.find(tool => tool.id === toolId);
  return tool ? tool.component : null;
};

// Export tools array for use in routing
export const toolRoutes = tools.filter(tool => tool.component !== null); 